import React from 'react'
import LayoutFull from '../../layouts/layoutFull/LayoutFull';
import { DEBUG, NAME_PROJECT, URL_BASE } from "../../settings/global";
import { createFetchAsync } from "../../helpers/fetch/fetchRequestAsync";
import { SeoCommon, SeoOpenGraph } from "../../helpers/seo/seo";
import Breadcrumb, { BreadcrumbLayer } from "../../components/Breadcrumb";
import Link from "next/link";
import styles from './[cloudName].module.scss';
import { convertEditorStateToHTML } from "../../components/draftEditor/export/exports";
import { generateSlug } from "../../helpers/common";
import TextPageLayout from "../../layouts/pages/article/TextPageLayout";
import Head from "next/head";
import { useRouter } from "next/router";
import DraftHTML from "../../components/draftEditor/export/DraftHTML";
import { NAV_CLOUDS } from "../../settings/navigation";
import { API_CLOUDS_CURRENCIES_CATEGORIES_INTERNAL } from "../../settings/endpoints/app";

export async function getStaticPaths() {

    let clouds = [];
    let cloudsCurrenciesCategories = await createFetchAsync({
        URL: API_CLOUDS_CURRENCIES_CATEGORIES_INTERNAL,
    });

    if (cloudsCurrenciesCategories.success && !!cloudsCurrenciesCategories.data) {

        clouds = cloudsCurrenciesCategories.data.cloud;

        clouds = clouds.map(c => {
            let newCloud = c;
            delete newCloud.description;
            return newCloud
        })

        if (!DEBUG) clouds = clouds.filter(c => !c.lock && !!c.impl);

        clouds = clouds.sort((a, b) => ('' + a.name).localeCompare(b.name));
    }

    let paths = [];

    clouds.map(cloud => {
        paths.push({params: {cloudName: 'deploy-to-' + generateSlug(cloud.name)}})
    });

    return {
        paths,
        fallback: 'blocking',
    }
}

export async function getStaticProps({params}) {

    let clouds = [];
    let cloudsCurrenciesCategories = await createFetchAsync({
        URL: API_CLOUDS_CURRENCIES_CATEGORIES_INTERNAL,
    });
    let {cloudName} = params;
    let foundCloud = null;

    if (cloudsCurrenciesCategories.success && !!cloudsCurrenciesCategories.data) {

        clouds = cloudsCurrenciesCategories.data['cloud'];

        foundCloud = {...clouds.find(c => 'deploy-to-' + generateSlug(c.name) === cloudName)};
        if (!foundCloud) {return {props: {}, notFound: true}}

        delete foundCloud.description;
        const articleExists = !!foundCloud.help && JSON.parse(foundCloud.help)?.blocks?.some(b => !!b.text);
        if (!articleExists) {return {props: {}, notFound: true}}
        const help = convertEditorStateToHTML(JSON.parse(foundCloud.help), {});
        delete foundCloud.help;

        foundCloud.help = help;
    }

    return {
        props: {
            cloud: foundCloud,
        }
    };
}

export default function CloudHelpPage({cloud}) {

    const router = useRouter();

    return (
        <LayoutFull>
            <SeoCommon tags={{
                title: `How to deploy on ${cloud['name']} | Clouds`,
                description: `Step by step guide how to deploy on ${cloud['name']} using ${NAME_PROJECT}`,
            }}/>
            <SeoOpenGraph
                tags={{
                    title: `How to deploy on ${cloud['name']} | Clouds`,
                    description: `Step by step guide how to deploy on ${cloud['name']} using ${NAME_PROJECT}`,
                }}
            />

            <Head>
                <link rel="canonical" href={`${URL_BASE}${NAV_CLOUDS}/${router.query.cloudName}`} key='canon'/>
            </Head>

            <TextPageLayout
                breadcrumb={
                    <Breadcrumb inverse>
                        <BreadcrumbLayer link='/' name='Home'/>
                        <BreadcrumbLayer link='/clouds' name='Clouds'/>
                        <BreadcrumbLayer name={`Deploy to ${cloud['name']}`}/>
                    </Breadcrumb>
                }
                title={`How to deploy to ${cloud['name']}`}
            >
                <Link href={NAV_CLOUDS} className={styles.link}>

                    <i className='fas fa-arrow-left'/>Browse all available clouds
                </Link>
                <article>
                    <DraftHTML className={`content-editor ${styles.stackDescription}`} content={cloud.help}/>
                </article>
            </TextPageLayout>
        </LayoutFull>
    );
}